
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'createDashboardTitle': 'Skapa kontrollpanel',
	'dashboard': 'Kontrollpanel',
	'dashboardTemplate': 'Kontrollpanelsmall',
	'createAV': 'Skapa',
	'createAvEditNameLabel': '1. Namnge vyn',
	'createAvSelectTemplateLabel': '2. Välj en mall',
	'tabLayoutLabel': 'Flikmall',
	'infographicsLayoutLabel': 'Infografikmall',
	'singlePageLayoutLabel': 'Ensidesmall',
	'customLayoutLabel': 'Anpassad mall',
	'freeformTemplate': 'Fritt format',
	'freeformTemplateDesc': 'Visualiseringar i fritt format visas exakt som du anger dem i vyn, oavsett skärmstorlek. Med andra layouter anpassas storlek och placering efter skärmen.',
	'NoTemplate': 'Ingen mall',
	'Template1': 'Tom',
	'Template2': 'Rubrik 1 av 2',
	'Template3': '2 över 1',
	'Template4': '4 över 1',
	'Template5': 'Sidfot 1 av 2',
	'Template6': '3 bredvid 1 över 1',
	'Template7': '4 bredvid 3 över 1',
	'Template8': '2 över 3 av 2',
	'Template9': '2 av 2',
	'Template10': '1 av 2 bredvid 2 av 2 över 1',
	'Template11': '3 av 1 över 1 av 2',
	'Template12': '2 över 1 bredvid 1 av 2',
	'Template13': '1 bredvid 1 av 2 bredvid 1 av 4',
	'Template22': '1 över 2 av 2',
	'Template14': '1 bredvid 1',
	'Template15': '1 över 1 bredvid 1',
	'Template16': '1 bredvid 1 över 1',
	'Template17': '1 över 1 bredvid 1 över 1',
	'Template18': '1 över 1 bredvid 1',
	'Template19': '1 över 2 bredvid 1',
	'Template20': '1 över 2 av 1',
	'Template21': '1 över 1 över 2 av 1',
	'Template23': 'Tom med släppzon',
	'Infographics1': 'Tom',
	'Infographics2': '4 rader',
	'Infographics3': '4 rader med rubriker',
	'Infographics4': '2 av 4',
	'Infographics5': 'Stor övre del med 2 av 2',
	'Infographics6': '2 av 4 med vertikalt avstånd',
	'Infographics7': '2 av 4 förskjutet',
	'Infographics8': 'Tennisbana',
	'Infographics9': '3 av 4',
	'Infographics10': '4 av 8',
	'createAvDashboardLabel': 'Layout',
	'dashboard_template_save_success': 'Kontrollpanelsmallen har sparats.',
	'dashboard_template_prefix': 'Mall: "%{name}"',
	'dashboard_template_filters_removed': 'Filter på arbetsytan har tagits bort.',
	'createAvTabLabel': 'Flikar',
	'createAvInfographicsLabel': 'Infografisk',
	'createAvSinglepageLabel': 'Enstaka sida',
	'createAvCustomLabel': 'Anpassat',
	'loadMoreLabel': 'Läs in mer...',
	'backLabel': 'Gå tillbaka',
	'addSourceLabel': 'Lägg till källa',
	'pinLabel': 'Fäst',
	'errorLoadingDataSetMetaData': 'Fel vid läsning av metadata',
	'errorLoadingDataSets': 'Fel vid inläsning av listan över datamängder.',
	'errorLoadingDataSet': 'Metadata för datamängden "%{datasetName}" lästes inte in. KOntakta administratören för mer information.',
	'okButton': 'OK',
	'createButton': 'Skapa',
	'cancelButton': 'Avbryt',
	'copyButton': 'Kopiera',
	'selectTemplateLabel': 'Välj en mall',
	'createBoardTitle': 'Skapa en kontrollpanel',
	'createBoardSubtitle': 'Välj en mall för kontrollpanelen',
	'noSourcesSelectedLabel': 'Ingen källa har valts',
	'find_label': 'Sök',
	'noDashboardFound': 'Det går inte att hämta kontrollpanelen. Den kanske inte finns längre eller så saknar du behörighet att se den.',
	'errorLabel': 'Fel',
	'defaultName': 'Ny kontrollpanel',
	'noDashboardCapability': 'Du har inte behörighet att köra kontrollpanelprogrammet',
	'noDashboardPermission': 'Du har inte behörighet att visa kontrollpanelen',
	'sourceNotFound': 'Det går inte att läsa in visualiseringen eftersom dess associerade källa "%{sourceName}" inte är tillgänglig',
	'cmDuplicateName': 'Det finns redan ett objekt med samma namn. Välj ett annat namn.',
	'cmEmptySelection': 'Kontrollpanelen har tagits bort. Försök spara som ny kontrollpanel.',
	'propTheme': 'Visuellt tema',
	'legacyThemeLabel': 'Äldre',
	'carbonGrey10Label': 'Kol X ljus',
	'carbonGrey100Label': 'Kol X mörk',
	'titleTextLabel': 'Rubrik',
	'titleSmallTextLabel': 'Liten rubrik',
	'subtitleTextLabel': 'Underrubrik',
	'bodyTextLabel': 'Brödtext',
	'bodySmallTextLabel': 'Litet textinnehåll',
	'captionTextLabel': 'Objekttext',
	'quoteTextLabel': 'Citat',
	'quoteSmallTextLabel': 'Litet citat',
	'responsiveTextLabel': 'Automatisk storlek',
	'mediaWidgetLabel': 'Media',
	'webpageWidgetLabel': 'Webbsida',
	'imageWidgetLabel': 'Bild',
	'textWidgetLabel': 'Text',
	'notebookWidgetLabel': 'Anteckningsbok',
	'multipurposeWidgetLabel': 'Flerfunktion',
	'textPlaceHolder': 'Klicka för att redigera text',
	'titlePlaceHolder': 'Klicka för att redigera rubrik',
	'toggleEditModeLabel': 'Växla för att ändra',
	'togglePreviewModeLabel': 'Växla för att förhandsgranska',
	'editDashboardCoachMarkTitle': 'Redigera kontrollpanel',
	'editDashboardCoachMarkContents': 'Klicka på pennan om du vill ändra kontrollpanelen.',
	'addDataCoachMarkTitle': 'Lägg till data',
	'addDataDashboardCoachMarkContents': 'Dra data från datapanelen till kontrollpanelen.',
	'pageSelectWarning': 'Välj en flik.',
	'screenshot_label': 'Kontrollpanel %{title}',
	'screenshot_label_tab': 'Flik %{tabName} i kontrollpanel %{title}',
	'dataAssetPropertiesLabel': 'Visualiseringsegenskaper',
	'modelFilter': 'Filter',
	'invertSelectionToolTip': 'Invertera filterval',
	'clearFilterValueToolTip': 'Rensa filtervärden',
	'invertFilterSelection': 'Invertera',
	'clearTextFilterValue': 'Rensa',
	'filterConditionLabel': 'Filtervillkor',
	'applyFilter': 'Använd filter',
	'itemCountText': '%{itemCount} objekt har valts',
	'itemExcludeCountText': '%{itemCount} objekt har exkluderats',
	'moreMembers': 'Visa fler...',
	'searchHierarchyMembers': 'Sök för att hitta medlemmar...',
	'propHideEmpty': 'Dölj tom',
	'propColorOrder': 'Färgordning',
	'propElementColor': 'Visualiseringselementfärg',
	'propLineColor': 'Linjefärg',
	'propLineAndSymbolColor': 'Linje- och symbolfärg',
	'propColumnColor': 'Kolumnfärg',
	'propBarColor': 'Stapelfärg',
	'propWordColor': 'Ordfärg',
	'propAreaColor': 'Ytfärg',
	'propRadialbarColor': 'Färg på radiell stapel',
	'propColorPalettes': 'Färgpaletter',
	'propDashboardColorPalette': 'Aktuell kontrollpanelpalett',
	'propNewDashboardPaletteLabel': 'Skapa en anpassad kontrollpanelpalett',
	'propDashboardChangePaletteLink': 'Ändra kontrollpanelpalett',
	'propHideLeafNode': 'Dölj etiketter',
	'propOpacity': 'Opacitet',
	'propOpacityDescription': 'Gör objektet mer eller mindre ogenomskinligt. Skriv ett värde från 0 till 100.',
	'addATab': 'Lägg till flik',
	'propFredIsRed': 'Färgkonsistens',
	'areaChartCaption': 'Yta',
	'areaChartDataSlot_categoriesLabel': 'Axeletikett',
	'areaChartDataSlot_valuesLabel': 'Värde',
	'areaChartProp_colorPaletteLabel': 'Färgpaletter',
	'areaChartProp_lineColorLabel': 'Ytfärg',
	'areaChartProp_interpolationLabel': 'Jämna linjer',
	'areaChartProp_interpolationDescription': 'Linjer som sammanbinder datapunkterna är svängda.',
	'areaChartProp_hideGridLinesLabel': 'Dölj rutnätslinjer',
	'areaChartProp_hideGridLinesDescription': 'Dölj rutnätslinjer',
	'areaChartProp_hideAxisTitleLabelsLabel': 'Dölj axelrubriksetiketter',
	'areaChartProp_hideAxisTitleLabelsDescription': 'Dölj axelrubriker',
	'areaChartProp_maintainAxisScalesLabel': 'Behåll axelskala',
	'areaChartProp_maintainAxisScalesDescription': 'Visa alltid minsta och största värde på axlarna.',
	'areaChartProp_suppressZerosLabel': 'Dölj tom',
	'areaChartProp_suppressZerosDescription': 'Dölj kategorier utan associerade värden.',
	'barChartCaption': 'Liggande stapel',
	'barChartDataSlot_categoriesLabel': 'Axeletikett',
	'barChartDataSlot_valuesLabel': 'Värde',
	'barChartProp_colorPaletteLabel': 'Färgpaletter',
	'barChartProp_elementColorLabel': 'Stapelfärg',
	'barChartProp_hideGridLinesLabel': 'Dölj rutnätslinjer',
	'barChartProp_hideGridLinesDescription': 'Dölj rutnätslinjer',
	'barChartProp_hideAxisTitleLabelsLabel': 'Dölj axelrubriksetiketter',
	'barChartProp_hideAxisTitleLabelsDescription': 'Dölj axelrubriker',
	'barChartProp_maintainAxisScalesLabel': 'Behåll axelskala',
	'barChartProp_maintainAxisScalesDescription': 'Visa alltid minsta och största värde på axlarna.',
	'barChartProp_suppressZerosLabel': 'Dölj tom',
	'barChartProp_suppressZerosDescription': 'Dölj kategorier utan associerade värden.',
	'columnChartCaption': 'Kolumn',
	'columnChartDataSlot_categoriesLabel': 'Axeletikett',
	'columnChartDataSlot_valuesLabel': 'Värde',
	'columnChartProp_colorPaletteLabel': 'Färgpaletter',
	'columnChartProp_elementColorLabel': 'Kolumnfärg',
	'columnChartProp_hideGridLinesLabel': 'Dölj rutnätslinjer',
	'columnChartProp_hideGridLinesDescription': 'Dölj rutnätslinjer',
	'columnChartProp_hideAxisTitleLabelsLabel': 'Dölj axelrubriksetiketter',
	'columnChartProp_hideAxisTitleLabelsDescription': 'Dölj axelrubriker',
	'columnChartProp_maintainAxisScalesLabel': 'Behåll axelskala',
	'columnChartProp_maintainAxisScalesDescription': 'Visa alltid minsta och största värde på axlarna.',
	'columnChartProp_suppressZerosLabel': 'Dölj tom',
	'columnChartProp_suppressZerosDescription': 'Dölj kategorier utan associerade värden.',
	'bubbleChartCaption': 'Bubbla',
	'bubbleChartDataSlot_xAxisLabel': 'Horisontell axel',
	'bubbleChartDataSlot_yAxisLabel': 'Vertikal axel',
	'bubbleChartDataSlot_sizeLabel': 'Storlek efter',
	'bubbleChartDataSlot_colorLabel': 'Färg efter',
	'bubbleChartProp_colorPaletteLabel': 'Färgpaletter',
	'bubbleChartProp_hideGridLinesLabel': 'Dölj rutnätslinjer',
	'bubbleChartProp_hideGridLinesDescription': 'Dölj rutnätslinjer',
	'bubbleChartProp_hideAxisTitleLabelsLabel': 'Dölj axelrubriksetiketter',
	'bubbleChartProp_hideAxisTitleLabelsDescription': 'Dölj axelrubriker',
	'bubbleChartProp_maintainAxisScalesLabel': 'Behåll axelskala',
	'bubbleChartProp_maintainAxisScalesDescription': 'Visa alltid minsta och största värde på axlarna.',
	'bubbleChartProp_hideLegendLabel': 'Dölj teckenförklaring',
	'bubbleChartProp_hideLegendDescription': 'Dölj teckenförklaringen.',
	'bubbleChartProp_legendPositionLabel': 'Teckenförklaringsplacering',
	'lineChartCaption': 'Linje',
	'lineChartDataSlot_categoriesLabel': 'Axeletikett',
	'lineChartDataSlot_valuesLabel': 'Värde',
	'lineChartProp_colorPaletteLabel': 'Färgpaletter',
	'lineChartProp_lineColorLabel': 'Linje- och symbolfärg',
	'lineChartProp_symbolShapeLabel': 'Symbolform',
	'lineChartProp_hideSymbolsLabel': 'Dölj symboler',
	'lineChartProp_hideSymbolsDescription': 'Dölj symboler',
	'lineChartProp_hideDataLinesLabel': 'Dölj linjer',
	'lineChartProp_hideDataLinesDescription': 'Dölj linjer',
	'lineChartProp_interpolationLabel': 'Jämna linjer',
	'lineChartProp_interpolationDescription': 'Linjer som sammanbinder datapunkterna är svängda.',
	'lineChartProp_hideGridLinesLabel': 'Dölj rutnätslinjer',
	'lineChartProp_hideGridLinesDescription': 'Dölj rutnätslinjer',
	'lineChartProp_hideAxisTitleLabelsLabel': 'Dölj axelrubriksetiketter',
	'lineChartProp_hideAxisTitleLabelsDescription': 'Dölj axelrubriker',
	'lineChartProp_maintainAxisScalesLabel': 'Behåll axelskala',
	'lineChartProp_maintainAxisScalesDescription': 'Visa alltid minsta och största värde på axlarna.',
	'lineChartProp_suppressZerosLabel': 'Dölj tom',
	'lineChartProp_suppressZerosDescription': 'Dölj kategorier utan associerade värden.',
	'packedBubbleChart1CatCaption': 'Packad bubbla',
	'packedBubbleChart1CatDataSlot_categoriesLabel': 'Kategorier',
	'packedBubbleChart1CatDataSlot_sizeLabel': 'Storlek efter',
	'packedBubbleChart1CatProp_colorPaletteLabel': 'Färgpaletter',
	'packedBubbleChart1CatProp_elementColorLabel': 'Bubbelfärg',
	'packedBubbleChart1CatProp_hideLabelLabel': 'Dölj etikett',
	'packedBubbleChart1CatProp_hideValueLabel': 'Dölj värde',
	'packedBubbleChart1CatProp_maintainAxisScalesLabel': 'Behåll axelskala',
	'packedBubbleChart1CatProp_maintainAxisScalesDescription': 'Visa alltid minsta och största värde på axlarna.',
	'packedBubbleChart1CatProp_suppressZerosLabel': 'Dölj tom',
	'packedBubbleChart1CatProp_suppressZerosDescription': 'Dölj kategorier utan associerade värden.',
	'heatChartCaption': 'Värme',
	'heatChartDataSlot_valuesLabel': 'Värme efter',
	'heatChartDataSlot_xAxisLabel': 'Horisontell axel',
	'heatChartDataSlot_yAxisLabel': 'Vertikal axel',
	'heatChartProp_colorPaletteLabel': 'Färgpaletter',
	'heatChartProp_heatScalePaletteLabel': 'Färgordning',
	'heatChartProp_hideAxisTitleLabelsLabel': 'Dölj axelrubriksetiketter',
	'heatChartProp_hideAxisTitleLabelsDescription': 'Dölj axelrubriker',
	'heatChartProp_maintainAxisScalesLabel': 'Behåll axelskala',
	'heatChartProp_maintainAxisScalesDescription': 'Visa alltid minsta och största värde på axlarna.',
	'heatChartProp_suppressZerosLabel': 'Dölj tom',
	'heatChartProp_suppressZerosDescription': 'Dölj kategorier utan associerade värden.',
	'heatChartProp_hideLegendLabel': 'Dölj teckenförklaring',
	'heatChartProp_hideLegendDescription': 'Dölj teckenförklaringen.',
	'heatChartProp_legendPositionLabel': 'Teckenförklaringsplacering',
	'pieChartCaption': 'Cirkel',
	'pieChartDataSlot_categoriesLabel': 'Kategorier',
	'pieChartDataSlot_valuesLabel': 'Värde',
	'pieChartProp_colorPaletteLabel': 'Färgpaletter',
	'pieChartProp_hideRadialValueLabel': 'Dölj värde',
	'pieChartProp_pieAsDonutLabel': 'Visa som ringdiagram',
	'pieChartProp_pieAsDonutDescription': 'Visa som ringdiagram',
	'pieChartProp_suppressZerosLabel': 'Dölj tom',
	'pieChartProp_suppressZerosDescription': 'Dölj kategorier utan associerade värden.',
	'pieChartProp_hideLegendLabel': 'Dölj teckenförklaring',
	'pieChartProp_hideLegendDescription': 'Dölj teckenförklaringen.',
	'pieChartProp_legendPositionLabel': 'Teckenförklaringsplacering',
	'map1measureCaption': 'Karta',
	'map1measureDataSlot_categoriesLabel': 'Regioner',
	'map1measureDataSlot_valuesLabel': 'Regionvärme',
	'map1measureProp_colorPaletteLabel': 'Färgpaletter',
	'map1measureProp_heatScalePaletteLabel': 'Färgordning',
	'map1measureProp_maintainAxisScalesLabel': 'Behåll axelskala',
	'map1measureProp_maintainAxisScalesDescription': 'Visa alltid minsta och största värde på axlarna.',
	'map1measureProp_suppressZerosLabel': 'Dölj tom',
	'map1measureProp_suppressZerosDescription': 'Dölj kategorier utan associerade värden.',
	'map1measureProp_hideLegendLabel': 'Dölj teckenförklaring',
	'map1measureProp_hideLegendDescription': 'Dölj teckenförklaringen.',
	'map1measureProp_legendPositionLabel': 'Teckenförklaringsplacering',
	'radialChartCaption': 'Radiell',
	'radialChartDataSlot_categoriesLabel': 'Kategorier',
	'radialChartDataSlot_valuesLabel': 'Värde',
	'radialChartProp_colorPaletteLabel': 'Färgpaletter',
	'radialChartProp_elementColorLabel': 'Färg på radiell stapel',
	'radialChartProp_hideRadialTitleLabel': 'Dölj rubrik',
	'radialChartProp_hideRadialValueLabel': 'Dölj värde',
	'radialChartProp_maintainAxisScalesLabel': 'Behåll axelskala',
	'radialChartProp_maintainAxisScalesDescription': 'Visa alltid minsta och största värde på axlarna.',
	'radialChartProp_suppressZerosLabel': 'Dölj tom',
	'radialChartProp_suppressZerosDescription': 'Dölj kategorier utan associerade värden.',
	'pointChart1catCaption': 'Punkt',
	'pointChart1catDataSlot_valuesLabel': 'Värde',
	'pointChart1catDataSlot_categoriesLabel': 'Axeletikett',
	'pointChart1catProp_colorPaletteLabel': 'Färgpaletter',
	'pointChart1catProp_elementColorLabel': 'Formfärg',
	'pointChart1catProp_symbolShapeLabel': 'Symbolform',
	'pointChart1catProp_symbolFillLabel': 'Fyllningsform',
	'pointChart1catProp_symbolFillDescription': 'Visa fyllningsfärg för symbolerna.',
	'pointChart1catProp_hideGridLinesLabel': 'Dölj rutnätslinjer',
	'pointChart1catProp_hideGridLinesDescription': 'Dölj rutnätslinjer',
	'pointChart1catProp_hideAxisTitleLabelsLabel': 'Dölj axelrubriksetiketter',
	'pointChart1catProp_hideAxisTitleLabelsDescription': 'Dölj axelrubriker',
	'pointChart1catProp_maintainAxisScalesLabel': 'Behåll axelskala',
	'pointChart1catProp_maintainAxisScalesDescription': 'Visa alltid minsta och största värde på axlarna.',
	'pointChart1catProp_suppressZerosLabel': 'Dölj tom',
	'pointChart1catProp_suppressZerosDescription': 'Dölj kategorier utan associerade värden.',
	'scatterPlotChartNoCatCaption': 'Spridning',
	'scatterPlotChartNoCatDataSlot_xAxisLabel': 'Horisontell axel',
	'scatterPlotChartNoCatDataSlot_yAxisLabel': 'Vertikal axel',
	'scatterPlotChartNoCatProp_colorPaletteLabel': 'Färgpaletter',
	'scatterPlotChartNoCatProp_elementColorLabel': 'Elementfärg',
	'scatterPlotChartNoCatProp_symbolShapeLabel': 'Symbolform',
	'scatterPlotChartNoCatProp_symbolFillLabel': 'Fyllningsform',
	'scatterPlotChartNoCatProp_symbolFillDescription': 'Visa fyllningsfärg för symbolerna.',
	'scatterPlotChartNoCatProp_hideGridLinesLabel': 'Dölj rutnätslinjer',
	'scatterPlotChartNoCatProp_hideGridLinesDescription': 'Dölj rutnätslinjer',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsLabel': 'Dölj axelrubriksetiketter',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsDescription': 'Dölj axelrubriker',
	'radialBarChartCaption': 'Radarstapel',
	'radialBarChartDataSlot_categoriesLabel': 'Kategorier',
	'radialBarChartDataSlot_valuesLabel': 'Värde',
	'radialBarChartProp_colorPaletteLabel': 'Färgpaletter',
	'radialBarChartProp_elementColorLabel': 'Färg på radiell stapel',
	'radialBarChartProp_hideRadialTitleLabel': 'Dölj rubrik',
	'radialBarChartProp_maintainAxisScalesLabel': 'Behåll axelskala',
	'radialBarChartProp_maintainAxisScalesDescription': 'Visa alltid minsta och största värde på axlarna.',
	'radialBarChartProp_suppressZerosLabel': 'Dölj tom',
	'radialBarChartProp_suppressZerosDescription': 'Dölj kategorier utan associerade värden.',
	'lineColumnComboChartCaption': 'Linje och stapel',
	'lineColumnComboChartDataSlot_categoryLabel': 'Axeletikett',
	'lineColumnComboChartDataSlot_lineValueLabel': 'Linjevärde',
	'lineColumnComboChartDataSlot_columnValueLabel': 'Stapelvärde',
	'lineColumnComboChartProp_colorPaletteLabel': 'Färgpaletter',
	'lineColumnComboChartProp_elementColorLabel': 'Kolumnfärg',
	'lineColumnComboChartProp_lineColorLabel': 'Linje- och symbolfärg',
	'lineColumnComboChartProp_symbolShapeLabel': 'Symbolform',
	'lineColumnComboChartProp_hideSymbolsLabel': 'Dölj symboler',
	'lineColumnComboChartProp_hideSymbolsDescription': 'Dölj symboler',
	'lineColumnComboChartProp_hideDataLinesLabel': 'Dölj linjer',
	'lineColumnComboChartProp_hideDataLinesDescription': 'Dölj linjer',
	'lineColumnComboChartProp_interpolationLabel': 'Jämna linjer',
	'lineColumnComboChartProp_interpolationDescription': 'Linjer som sammanbinder datapunkterna är svängda.',
	'lineColumnComboChartProp_hideGridLinesLabel': 'Dölj rutnätslinjer',
	'lineColumnComboChartProp_hideGridLinesDescription': 'Dölj rutnätslinjer',
	'lineColumnComboChartProp_hideAxisTitleLabelsLabel': 'Dölj axelrubriksetiketter',
	'lineColumnComboChartProp_hideAxisTitleLabelsDescription': 'Dölj axelrubriker',
	'lineColumnComboChartProp_maintainAxisScalesLabel': 'Behåll axelskala',
	'lineColumnComboChartProp_maintainAxisScalesDescription': 'Visa alltid minsta och största värde på axlarna.',
	'lineColumnComboChartProp_suppressZerosLabel': 'Dölj tom',
	'lineColumnComboChartProp_suppressZerosDescription': 'Dölj kategorier utan associerade värden.',
	'lineColumnComboChartProp_hideLegendLabel': 'Dölj teckenförklaring',
	'lineColumnComboChartProp_hideLegendDescription': 'Dölj teckenförklaringen.',
	'lineColumnComboChartProp_legendPositionLabel': 'Teckenförklaringsplacering',
	'summaryCaption': 'Sammanfattning',
	'areaName': 'Yta',
	'areaDescription': 'Yta',
	'areaDataSlot_colorLabel': 'Färg efter',
	'areaDataSlot_valuesLabel': 'Värde',
	'areaDataSlot_categoriesLabel': 'Axeletikett',
	'bubbleName': 'Bubbla',
	'bubbleDescription': 'Bubbla',
	'bubbleDataSlot_yAxisLabel': 'Vertikal axel',
	'bubbleDataSlot_xAxisLabel': 'Horisontell axel',
	'bubbleDataSlot_sizeLabel': 'Storlek efter',
	'bubbleDataSlot_colorLabel': 'Färg efter',
	'clusterBarName': 'Liggande stapel',
	'clusterBarDescription': 'Liggande stapel',
	'clusterBarDataSlot_colorLabel': 'Färg efter',
	'clusterBarDataSlot_valuesLabel': 'Värde',
	'clusterBarDataSlot_categoriesLabel': 'Axeletikett',
	'clusterBarDataSlot_valuesRepeatingLabel': 'Värde',
	'clusterColumnName': 'Kolumn',
	'clusterColumnDescription': 'Kolumn',
	'clusterColumnDataSlot_colorLabel': 'Färg efter',
	'clusterColumnDataSlot_valuesLabel': 'Värde',
	'clusterColumnDataSlot_categoriesLabel': 'Axeletikett',
	'clusterColumnDataSlot_valuesRepeatingLabel': 'Värde',
	'clusterLineName': 'Linje',
	'clusterLineDescription': 'Linje',
	'clusterLineDataSlot_colorLabel': 'Färg efter',
	'clusterLineDataSlot_valuesLabel': 'Vertikal axel',
	'clusterLineDataSlot_categoriesLabel': 'Horisontell axel',
	'clusterLineDataSlot_valuesRepeatingLabel': 'Värde',
	'gridName': 'Rutnät',
	'gridDescription': 'Rutnät',
	'gridDataSlot_grid_colsLabel': 'Kolumn',
	'heatName': 'Värme',
	'heatDescription': 'Värme',
	'heatDataSlot_yAxisLabel': 'Vertikal axel',
	'heatDataSlot_xAxisLabel': 'Horisontell axel',
	'heatDataSlot_valuesLabel': 'Värme efter',
	'lineColumnComboName': 'Linje och stapel',
	'lineColumnComboDescription': 'Linje och stapel',
	'lineColumnComboDataSlot_lineValueLabel': 'Linjevärde',
	'lineColumnComboDataSlot_categoryLabel': 'Axeletikett',
	'lineColumnComboDataSlot_columnValueLabel': 'Stapelvärde',
	'mapName': 'Avvecklad karta',
	'mapDescription': 'Avvecklad karta',
	'mapDataSlot_sizeLabel': 'Punktstorlek',
	'mapDataSlot_valuesLabel': 'Regionvärme',
	'mapDataSlot_sizeHeatLabel': 'Punktvärme',
	'mapDataSlot_categoriesLabel': 'Regioner',
	'packedBubbleName': 'Packad bubbla',
	'packedBubbleDescription': 'Packad bubbla',
	'packedBubbleDataSlot_sizeLabel': 'Storlek efter',
	'packedBubbleDataSlot_colorLabel': 'Färg efter',
	'packedBubbleDataSlot_categoriesLabel': 'Kategorier',
	'pieName': 'Cirkel',
	'pieDescription': 'Cirkel',
	'pieDataSlot_valuesLabel': 'Värde',
	'pieDataSlot_categoriesLabel': 'Kategorier',
	'playerName': 'Dataspelare',
	'playerDescription': 'Dataspelare',
	'playerDataSlot_categoriesLabel': 'Axeletikett',
	'pointName': 'Punkt',
	'pointDescription': 'Punkt',
	'pointDataSlot_colorLabel': 'Färg efter',
	'pointDataSlot_valuesLabel': 'Värde',
	'pointDataSlot_categoriesLabel': 'Axeletikett',
	'radialName': 'Radiell',
	'radialDescription': 'Radiell',
	'radialDataSlot_valuesLabel': 'Värde',
	'radialDataSlot_maxSizeLabel': 'Högsta värde',
	'radialDataSlot_categoriesLabel': 'Kategorier',
	'radialBarName': 'Radarstapel',
	'radialBarDescription': 'Radarstapel',
	'radialBarDataSlot_valuesLabel': 'Värde',
	'radialBarDataSlot_categoriesLabel': 'Kategorier',
	'scatterPlotName': 'Spridning',
	'scatterPlotDescription': 'Spridning',
	'scatterPlotDataSlot_yAxisLabel': 'Vertikal axel',
	'scatterPlotDataSlot_xAxisLabel': 'Horisontell axel',
	'scatterPlotDataSlot_colorLabel': 'Färg efter',
	'scatterPlotDataSlot_categoriesLabel': 'Punkter',
	'stackedBarName': 'Staplad liggande stapel',
	'stackedBarDescription': 'Staplad liggande stapel',
	'stackedBarDataSlot_colorLabel': 'Färg efter',
	'stackedBarDataSlot_valuesLabel': 'Värde',
	'stackedBarDataSlot_categoriesLabel': 'Axeletikett',
	'stackedBarDataSlot_valuesRepeatingLabel': 'Värde',
	'stackedColumnName': 'Staplad stapel',
	'stackedColumnDescription': 'Staplad stapel',
	'stackedColumnDataSlot_colorLabel': 'Färg efter',
	'stackedColumnDataSlot_valuesLabel': 'Värde',
	'stackedColumnDataSlot_categoriesLabel': 'Axeletikett',
	'stackedColumnDataSlot_valuesRepeatingLabel': 'Värde',
	'summaryChartName': 'Sammanfattning',
	'summaryChartDescription': 'Sammanfattning',
	'summaryChartDataSlot_valuesLabel': 'Värde',
	'treeMapName': 'Trädkarta',
	'treeMapDescription': 'Trädkarta',
	'treeMapDataSlot_colorLabel': 'Värme efter',
	'treeMapDataSlot_valuesLabel': 'Storlek efter',
	'treeMapDataSlot_categoriesLabel': 'Nivå ett',
	'treeMapDataSlot_level3Label': 'Nivå tre',
	'treeMapDataSlot_level2Label': 'Nivå två',
	'wordCloudName': 'Ordmoln',
	'wordCloudDescription': 'Ordmoln',
	'wordCloudDataSlot_colorLabel': 'Färg efter',
	'wordCloudDataSlot_scaleLabel': 'Storlek efter',
	'wordCloudDataSlot_wordLabel': 'Ord',
	'treeMap1Cat1MeasureChartCaption': 'Trädkarta',
	'treeMap1Cat1MeasureChartDataSlot_categoriesLabel': 'Nivå ett',
	'treeMap1Cat1MeasureChartDataSlot_valuesLabel': 'Storlek efter',
	'treeMap1Cat1MeasureChartProp_colorPaletteLabel': 'Färgpaletter',
	'treeMap1Cat2MeasureChartProp_colorPaletteLabel': 'Färgpaletter',
	'treeMap2Cat1MeasureChartProp_colorPaletteLabel': 'Färgpaletter',
	'treeMap2Cat2MeasureChartProp_colorPaletteLabel': 'Färgpaletter',
	'treeMap3Cat1MeasureChartProp_colorPaletteLabel': 'Färgpaletter',
	'treeMap3Cat2MeasureChartProp_colorPaletteLabel': 'Färgpaletter',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesLabel': 'Behåll axelskala',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesDescription': 'Visa alltid minsta och största värde på axlarna.',
	'treeMap1Cat1MeasureChartProp_suppressZerosLabel': 'Dölj tom',
	'treeMap1Cat1MeasureChartProp_suppressZerosDescription': 'Dölj kategorier utan associerade värden.',
	'treeMap1Cat1MeasureChartProp_hideLegendLabel': 'Dölj teckenförklaring',
	'treeMap1Cat1MeasureChartProp_hideLegendDescription': 'Dölj teckenförklaringen.',
	'treeMap1Cat1MeasureChartProp_legendPositionLabel': 'Teckenförklaringsplacering',
	'wordChart1Cat1MeasureCaption': 'Ordmoln',
	'wordChart1Cat1MeasureDataSlot_wordLabel': 'Ord',
	'wordChart1Cat1MeasureDataSlot_scaleLabel': 'Storlek efter',
	'wordChart1Cat1MeasureProp_colorPaletteLabel': 'Färgpaletter',
	'wordChart1Cat1MeasureProp_elementColorLabel': 'Ordfärg',
	'wordChart1Cat1MeasureProp_maintainAxisScalesLabel': 'Behåll axelskala',
	'wordChart1Cat1MeasureProp_maintainAxisScalesDescription': 'Visa alltid minsta och största värde på axlarna.',
	'wordChart1Cat1MeasureProp_suppressZerosLabel': 'Dölj tom',
	'wordChart1Cat1MeasureProp_suppressZerosDescription': 'Dölj kategorier utan associerade värden.',
	'missingDataSetData': 'Data för den här datamängden är inte tillgängliga. Uppdatera datamängden eller be administratören om åtkomst till källan.',
	'hideShowSummaries': 'Dölj/visa översikt',
	'crosstabName': 'Korstabell',
	'value_is_not_available': 'Ej tillämpligt',
	'swapRowsAndColumns': 'Växla rader och kolumner',
	'NoPinsCollected': 'Inga favoritvisualiseringar',
	'pinSearchOld': 'Sök i Mina favoriter',
	'pinDeletedToast': 'Favoriten togs bort',
	'pinAddedToast': 'Favoriten lades till i Mina favoriter',
	'pinRetrieveError': 'Det går inte att hämta ett eller fler uppsatta objekt. Försök igen senare.',
	'pinErrorTitle': 'Favoriseringsfel',
	'pinRemove': 'Radera favorit',
	'deletePin': 'Ta bort favorit',
	'dataset_time': 'tid',
	'dataset_date': 'datum',
	'dataset_location': 'plats',
	'dataset_number': 'tal',
	'dataset_text': 'text',
	'widgetConditionalFormatLabel': 'Kontroller för växling av villkorsformat',
	'deletePinConfirmationMessage': 'Vill du ta bort favoriten? Åtgärden kan inte ångras.',
	'deletePinConfirm': 'Bekräfta borttagning',
	'pinDeleteError': 'Det går inte att ta bort ett eller fler uppsatta objekt. Försök igen senare.',
	'metadataPickerTitle': 'Skapa datamängd',
	'moreTitle': 'Mer',
	'remove_slider_handle': 'Ta bort handtag',
	'missingFiltering': 'Kolumn saknas:',
	'unSupportedPromptType': 'Promptscenariot hanteras inte.',
	'preAggregateLabel': 'Tillämpa promptvärden från den här datakällan',
	'postAggregateLabel': 'Tillämpa promptvärden i rapporten',
	'preAggregateText': 'Intervallet använder värden i datakällan inte de värden som visas på kontrollpanelen.',
	'tabName_general': 'Allmänt', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_visDetails': 'Detaljer',
	'tabName_textDetails': 'Textdetaljer', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_mediaDetails': 'Mediadetaljer', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_webDetails': 'Webbsidesdetaljer', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_imageDetails': 'Bilddetaljer', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_visualization': 'Visualisering',
	'sectionName_canvas': 'Arbetsyta',
	'sectionName_colorsAndThemes': 'Färg och tema',
	'colorsAndThemes_legacyWarning': 'Den aktuella kontrollpanelen använder ett tema från en tidigare version. Om du ändrar temat och sparar kontrollpanelen tas åtkomsten till de tidigare temapaletterna bort permanent.',
	'sectionName_details': 'Detaljer',
	'sectionName_positionAndStyle': 'Position/format',
	'sectionName_appearance': 'Utseende', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'sectionName_advanced': 'Avancerat',
	'sectionName_layout': 'Layout', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'sectionName_tabs': 'Flikar',
	'sectionName_tabTitle': 'Etikett',
	'sectionName_tabBackground': 'Bakgrund',
	'addDataSourceDialogTitle': 'Lägg till en datakälla',
	'addDataSourceDialogButtonLabel': 'Lägg till',
	'shapesDoubleChevron': 'Dubbelt fiskben',
	'widgetsPanelTitle': 'Widgetar',
	'widgetsPanelBasicsTab': 'Grundläggande',
	'widgetsPanelImageLibraryTab': 'Bilder',
	'widgetsPanelSectionStandard': 'Standard',
	'widgetsPanelSectionAdvanced': 'Avancerat',
	'widgetsPanelSectionShapes': 'Former',
	'customWidgetsTitle': 'Anpassade widgetar',
	'filterItemCanvasMove': 'Lägg till på arbetsyta',
	'filterOverflowMenu_Global': 'Alla flikars spillmeny',
	'filterOverflowMenu_Tab': 'Den här flikens spillmeny',
	'filterOverflowMenu_Item': 'Filterspillmeny',
	'filterOverflowMenu_Single': 'Spillmeny',
	'filterItemEdit': 'Ändra filtervärden',
	'filterDeleteAllItems': 'Ta bort alla filter',
	'filterClearAllItems': 'Rensa alla filter',
	'filterClearSelection': 'Rensa filter',
	'filterPlayerMode': 'Visa spelare',
	'filterStaticMode': 'Visa lista',
	'filterInvertSelection': 'Invertera filter',
	'filterIconLabel_Global': 'Alla flikar',
	'filterIconLabel_Single': 'Filter',
	'filterIconLabel_Tab': 'Den här fliken',
	'filterIconTooltip_Global': 'Alla flikar',
	'filterIconTooltip_Tab': 'Den här fliken',
	'filterIconTooltip_Single': 'Filter',
	'filterItemDelete': 'Ta bort filter',
	'filterValueSeparator': ',',
	'filterRange': '%{from}-%{to}',
	'filterInvertRange': 'allt utom: %{from}-%{to}',
	'filterExcept': 'utom %{values}',
	'filterAll': 'Alla',
	'filterBlank': '(tom)',
	'filterDisableRangeInvert': 'Ej tillgängligt när den här kolumnen finns i filtret Alla flikar.',
	'filterDisableHierarchyInvert': 'Ej tillgängligt när den här kolumnen finns i ett hierarkifiltret.',
	'filterSelectedOfTotal': '%{selected} av %{totalMembers}',
	'filter_date_before': 'Före %{to}',
	'filter_date_before_except': 'Inte före %{to}',
	'filter_date_after': 'Efter %{from}',
	'filter_date_after_except': 'Inte efter %{from}',
	'filter_date_between': 'Mellan %{from}-%{to}',
	'filter_date_between_except': 'Inte mellan %{from}-%{to}',
	'filter_drag_and_drop_all_tabs': 'Dra data hit för att filtrera alla flikar.',
	'filter_drag_and_drop_current_tab': 'Dra data hit för att filtrera den här fliken.',
	'filter_drag_and_drop_single_dock': 'Dra data hit för att filtrera.',
	'errMsgFilterItemGenericTitle': 'Filtervärden kan inte läsas in',
	'widgetChromeRotate': 'Rotera',
	'toolbarRegionLabel': 'Verktygsfält',
	'toolbarActionDelete': 'Ta bort',
	'toolbarActionGroup': 'Gruppera',
	'toolbarActionUngroup': 'Dela upp grupp',
	'toolbarActionOrderToFront': 'Placera framför',
	'toolbarActionOrderToBack': 'Placera bakom',
	'toolbarActionEditTitle': 'Ändra titel',
	'toolbarActionWrapTitle': 'Bryt titeln',
	'toolbarActionPin': 'Samla in',
	'toolbarActionPinOld': 'Fäst',
	'toolbarActionAlign': 'Justera',
	'alignWidgetLeft': 'Vänster',
	'alignWidgetCenter': 'Centrerat',
	'alignWidgetRight': 'Höger',
	'alignWidgetTop': 'Överst',
	'alignWidgetMiddle': 'Mitten',
	'alignWidgetBottom': 'Nederst',
	'toolbarChangeVisualization': 'Ändra visualisering',
	'multipurposeHeader': 'Välj en widgettyp',
	'multipurposePlaceholderText': 'Välj en av widgetarna för att komma igång.',
	'live_label': 'Diagram',
	'filter_label': 'Filter',
	'one_named_live': '%{name} diagram',
	'one_named_live_numbered': '%{name} diagram (%{number})',
	'one_unknown_live': 'Diagram',
	'one_unknown_live_numbered': 'Diagram (%{number})',
	'few_live': 'Grupp av %{count} diagram',
	'many_live': 'Grupp av %{count} diagram',
	'one_custom': 'Anpassad widget',
	'one_custom_named': '%{name}',
	'one_custom_named_numbered': '%{name} (%{number})',
	'one_named_filter': '%{name} filter',
	'one_named_filter_numbered': '%{name} filter (%{number})',
	'one_unknown_filter': 'Filter',
	'one_unknown_filter_numbered': 'Filter (%{number})',
	'few_filter': 'Grupp av %{count} filter',
	'many_filter': 'Grupp av %{count} filter',
	'LIVE_bar_has_mapping': '%{values} liggande stapeldiagram',
	'LIVE_bar_has_mapping_numbered': '%{values} liggande stapeldiagram (%{number})',
	'LIVE_bar_opt_mapping': '%{categories} gånger %{values} liggande stapeldiagram',
	'LIVE_bar_opt_mapping_numbered': '%{categories} gånger %{values} liggande stapeldiagram (%{number})',
	'LIVE_bar_no_mapping': 'Tomt liggande stapeldiagram',
	'LIVE_bar_no_mapping_numbered': 'Tomt liggande stapeldiagram (%{number})',
	'LIVE_bar_named': '%{name} liggande stapeldiagram',
	'LIVE_bar_named_numbered': '%{name} liggande stapeldiagram (%{number})',
	'LIVE_stacked_bar_has_mapping': '%{values} staplat liggande stapeldiagram',
	'LIVE_stacked_bar_has_mapping_numbered': '%{values} staplat liggande stapeldiagram (%{number})',
	'LIVE_stacked_bar_opt_mapping': '%{categories} gånger {values} staplat liggande stapeldiagram',
	'LIVE_stacked_bar_opt_mapping_numbered': '%{categories} gånger {values} staplat liggande stapeldiagram (%{number})',
	'LIVE_stacked_bar_no_mapping': 'Tomt staplat liggande stapeldiagram',
	'LIVE_stacked_bar_no_mapping_numbered': 'Tomt staplat liggande stapeldiagram (%{number})',
	'LIVE_stacked_bar_named': '%{name} staplat liggande stapeldiagram',
	'LIVE_stacked_bar_named_numbered': '%{name} staplat liggande stapeldiagram (%{number})',
	'LIVE_bubble_has_mapping': 'Bubbeldiagram, %{categories} gånger %{x} och %{y}',
	'LIVE_bubble_has_mapping_numbered': 'Bubbeldiagram, %{categories} gånger {x} och %{y} (%{number})',
	'LIVE_bubble_no_mapping': 'Tomt bubbeldiagram',
	'LIVE_bubble_no_mapping_numbered': 'Tomt bubbeldiagram (%{number})',
	'LIVE_bubble_named': '%{name} bubbeldiagram',
	'LIVE_bubble_named_numbered': '%{name} bubbeldiagram (%{number})',
	'LIVE_composite_has_mapping': '%{categories} gånger %{columnValue} och %{lineValue} kombinationsdiagram',
	'LIVE_composite_has_mapping_numbered': '%{categories} gånger %{columnValue} och %{lineValue} kombinationsdiagram (%{number})',
	'LIVE_composite_no_mapping': 'Tomt kombinationsdiagram',
	'LIVE_composite_no_mapping_numbered': 'Tomt kombinationsdiagram (%{number})',
	'LIVE_composite_named': '%{name} kombinationsdiagram',
	'LIVE_composite_named_numbered': '%{name} kombinationsdiagram (%{number})',
	'LIVE_decision_tree_has_mapping': '%{values} beslutsträd',
	'LIVE_decision_tree_has_mapping_numbered': '%{values} beslutsträd (%{number})',
	'LIVE_decision_tree_no_mapping': 'Tomt beslutsträd',
	'LIVE_decision_tree_no_mapping_numbered': 'Tomt beslutsträd (%{number})',
	'LIVE_decision_tree_named': '%{name} beslutsträd',
	'LIVE_decision_tree_named_numbered': '%{name} beslutsträd (%{number})',
	'LIVE_packed_bubble_has_mapping': '%{categories} packat bubbeldiagram',
	'LIVE_packed_bubble_has_mapping_numbered': '%{categories} packat bubbeldiagram (%{number})',
	'LIVE_packed_bubble_no_mapping': 'Tomt packat bubbeldiagram',
	'LIVE_packed_bubble_no_mapping_numbered': 'Tomt packat bubbeldiagram (%{number})',
	'LIVE_packed_bubble_named': '%{name} packat bubbeldiagram',
	'LIVE_packed_bubble_named_numbered': '%{name} packat bubbeldiagram (%{number})',
	'LIVE_pie_has_mapping': '%{categories} gånger %{values} cirkeldiagram',
	'LIVE_pie_has_mapping_numbered': '%{categories} gånger %{values} cirkeldiagram (%{number})',
	'LIVE_pie_no_mapping': 'Tomt cirkeldiagram',
	'LIVE_pie_no_mapping_numbered': 'Tomt cirkeldiagram (%{number})',
	'LIVE_pie_named': '%{name} cirkeldiagram',
	'LIVE_pie_named_numbered': '%{name} cirkeldiagram (%{number})',
	'LIVE_pie_as_donut_has_mapping': '%{categories} gånger %{values} ringdiagram',
	'LIVE_pie_as_donut_has_mapping_numbered': '%{categories} gånger %{values} ringdiagram (%{number})',
	'LIVE_pie_as_donut_no_mapping': 'Tomt ringdiagram',
	'LIVE_pie_as_donut_no_mapping_numbered': 'Tomt ringdiagram (%{number})',
	'LIVE_pie_as_donut_named': '%{name} ringdiagram',
	'LIVE_pie_as_donut_named_numbered': '%{name} ringdiagram (%{number})',
	'LIVE_line_has_mapping': '%{categories} gånger %{values} linjediagram',
	'LIVE_line_has_mapping_numbered': '%{categories} gånger %{values} linjediagram (%{number})',
	'LIVE_line_no_mapping': 'Tomt linjediagram',
	'LIVE_line_no_mapping_numbered': 'Tomt linjediagram (%{number})',
	'LIVE_line_named': '%{name} linjediagram',
	'LIVE_line_named_numbered': '%{name} linjediagram (%{number})',
	'LIVE_area_has_mapping': '%{categories} gånger %{values} ytdiagram',
	'LIVE_area_has_mapping_numbered': '%{categories} gånger %{values} ytdiagram (%{number})',
	'LIVE_area_no_mapping': 'Tomt ytdiagram',
	'LIVE_area_no_mapping_numbered': 'Tomt ytdiagram (%{number})',
	'LIVE_area_named': '%{name} ytdiagram',
	'LIVE_area_named_numbered': '%{name} ytdiagram (%{number})',
	'LIVE_area_as_stacked_percent_has_mapping': '%{categories} gånger %{values} staplat procentytdiagram',
	'LIVE_area_as_stacked_percent_has_mapping_numbered': '%{categories} gånger %{values} staplat procentytdiagram (%{number})',
	'LIVE_area_as_stacked_percent_no_mapping': 'Tomt staplat procentytdiagram',
	'LIVE_area_as_stacked_percent_no_mapping_numbered': 'Tomt staplat procentytdiagram (%{number})',
	'LIVE_area_as_stacked_percent_named': '%{name} staplat procentytdiagram',
	'LIVE_area_as_stacked_percent_named_numbered': '%{name} staplat procentytdiagram (%{number})',
	'LIVE_heatmap_has_mapping': '%{color} värmekarta',
	'LIVE_heatmap_has_mapping_numbered': '%{color} värmekarta (%{number})',
	'LIVE_heatmap_no_mapping': 'Tom värmekarta',
	'LIVE_heatmap_no_mapping_numbered': 'Tom värmekarta (%{number})',
	'LIVE_heatmap_named': '%{name} värmekarta',
	'LIVE_heatmap_named_numbered': '%{name} värmekarta (%{number})',
	'LIVE_network_opt_mapping': '%{categories} gånger %{series} och %{values} nätverk',
	'LIVE_network_opt_mapping_numbered': '%{categories} gånger %{series} och %{values} nätverk (%{number})',
	'LIVE_network_has_mapping': '%{categories} gånger %{series} nätverk',
	'LIVE_network_has_mapping_numbered': '%{categories} gånger %{series} nätverk (%{number})',
	'LIVE_network_no_mapping': 'Tomt nätverk',
	'LIVE_network_no_mapping_numbered': 'Tomt nätverk (%{number})',
	'LIVE_network_named': '%{name} nätverk',
	'LIVE_network_named_numbered': '%{name} nätverk (%{number})',
	'LIVE_radial_bar_opt_mapping': '%{categories} gånger %{values} liggande radarstapeldiagram',
	'LIVE_radial_bar_opt_mapping_numbered': '%{categories} gånger %{values} liggande radarstapeldiagram (%{number})',
	'LIVE_radial_bar_has_mapping': '%{values} liggande radialstapeldiagram',
	'LIVE_radial_bar_has_mapping_numbered': '%{values} liggande radarstapeldiagram (%{number})',
	'LIVE_radial_bar_no_mapping': 'Tomt liggande radarstapeldiagram',
	'LIVE_radial_bar_no_mapping_numbered': 'Tomt liggande radarstapeldiagram (%{number})',
	'LIVE_radial_bar_named': '%{name} liggande radarstapeldiagram',
	'LIVE_radial_bar_named_numbered': '%{name} liggande radarstapeldiagram (%{number})',
	'LIVE_spiral_has_mapping': '%{values} spiraldiagram',
	'LIVE_spiral_has_mapping_numbered': '%{values} spiraldiagram (%{number})',
	'LIVE_spiral_no_mapping': 'Tomt spiraldiagram',
	'LIVE_spiral_no_mapping_numbered': 'Tomt spiraldiagram (%{number})',
	'LIVE_spiral_named': '%{name} spiraldiagram',
	'LIVE_spiral_named_numbered': '%{name} spiraldiagram (%{number})',
	'LIVE_treemap_has_mapping': '%{categories} gånger %{size} trädkarta',
	'LIVE_treemap_has_mapping_numbered': '%{categories} gånger %{size} trädkarta (%{number})',
	'LIVE_treemap_no_mapping': 'Tom trädkarta',
	'LIVE_treemap_no_mapping_numbered': 'Tom trädkarta (%{number})',
	'LIVE_treemap_named': '%{name} trädkarta',
	'LIVE_treemap_named_numbered': '%{name} trädkarta (%{number})',
	'LIVE_wordcloud_has_mapping': '%{categories} ordmoln',
	'LIVE_wordcloud_has_mapping_numbered': '%{categories} ordmoln (%{number})',
	'LIVE_wordcloud_no_mapping': 'Tomt ordmoln',
	'LIVE_wordcloud_no_mapping_numbered': 'Tomt ordmoln (%{number})',
	'LIVE_wordcloud_named': '%{name} ordmoln',
	'LIVE_wordcloud_named_numbered': '%{name} ordmoln (%{number})',
	'LIVE_data_player_has_mapping': '%{category} dataspelare',
	'LIVE_data_player_has_mapping_numbered': '%{category} dataspelare (%{number})',
	'LIVE_data_player_no_mapping': 'Tom dataspelare',
	'LIVE_data_player_no_mapping_numbered': 'Tom dataspelare (%{number})',
	'LIVE_data_player_named': '%{name} dataspelare',
	'LIVE_data_player_named_numbered': '%{name} dataspelare (%{number})',
	'LIVE_map_has_mapping': '%{locations} karta',
	'LIVE_map_has_mapping_numbered': '%{locations} karta (%{number})',
	'LIVE_map_no_mapping': 'Tom karta',
	'LIVE_map_no_mapping_numbered': 'Tom karta (%{number})',
	'LIVE_map_named': '%{name} karta',
	'LIVE_map_named_numbered': '%{name} karta (%{number})',
	'LIVE_point_has_mapping': '%{categories} gånger %{values} punktdiagram',
	'LIVE_point_has_mapping_numbered': '%{categories} gånger %{values} punktdiagram (%{number})',
	'LIVE_point_no_mapping': 'Tomt punktdiagram',
	'LIVE_point_no_mapping_numbered': 'Tomt punktdiagram (%{number})',
	'LIVE_point_named': '%{name} punktdiagram',
	'LIVE_point_named_numbered': '%{name} punktdiagram (%{number})',
	'LIVE_column_has_mapping': '%{values} stapeldiagram',
	'LIVE_column_has_mapping_numbered': '%{values} stapeldiagram (%{number})',
	'LIVE_column_opt_mapping': '%{categories} gånger %{values} stapeldiagram',
	'LIVE_column_opt_mapping_numbered': '%{categories} gånger %{values} stapeldiagram (%{number})',
	'LIVE_column_no_mapping': 'Tomt stapeldiagram',
	'LIVE_column_no_mapping_numbered': 'Tomt stapeldiagram (%{number})',
	'LIVE_column_named': '%{name} stapeldiagram',
	'LIVE_column_named_numbered': '%{name} stapeldiagram (%{number})',
	'LIVE_stacked_column_has_mapping': '%{values} staplat stapeldiagram',
	'LIVE_stacked_column_has_mapping_numbered': '%{values} staplat stapeldiagram (%{number})',
	'LIVE_stacked_column_opt_mapping': '%{categories} gånger %{values} staplat stapeldiagram',
	'LIVE_stacked_column_opt_mapping_numbered': '%{categories} gånger %{values} staplat stapeldiagram (%{number})',
	'LIVE_stacked_column_no_mapping': 'Tomt staplat stapeldiagram',
	'LIVE_stacked_column_no_mapping_numbered': 'Tomt staplat stapeldiagram (%{number})',
	'LIVE_stacked_column_named': '%{name} staplat stapeldiagram',
	'LIVE_stacked_column_named_numbered': '%{name} staplat stapeldiagram (%{number})',
	'LIVE_scatter_opt_mapping': '%{categories} gånger %{x} och %{y} spridningsdiagram',
	'LIVE_scatter_opt_mapping_numbered': '%{categories} gånger %{x} och %{y} spridningsdiagram (%{number})',
	'LIVE_scatter_has_mapping': '%{x} vs %{y} spridningsdiagram',
	'LIVE_scatter_has_mapping_numbered': '%{x} vs %{y} spridningsdiagram (%{number})',
	'LIVE_scatter_no_mapping': 'Tomt spridningsdiagram',
	'LIVE_scatter_no_mapping_numbered': 'Tomt spridningsdiagram (%{number})',
	'LIVE_scatter_named': '%{name} spridningsdiagram',
	'LIVE_scatter_named_numbered': '%{name} spridningsdiagram (%{number})',
	'LIVE_waterfall_has_mapping': '%{values} vattenfallsdiagram',
	'LIVE_waterfall_has_mapping_numbered': '%{values} vattenfallsdiagram (%{number})',
	'LIVE_waterfall_no_mapping': 'Tomt vattenfallsdiagram',
	'LIVE_waterfall_no_mapping_numbered': 'Tomt vattenfallsdiagram (%{number})',
	'LIVE_waterfall_named': '%{name} vattenfallsdiagram',
	'LIVE_waterfall_named_numbered': '%{name} vattenfallsdiagram (%{number})',
	'LIVE_empty_visualization_hint_title': 'Skapa visualisering',
	'LIVE_empty_visualization_hint_description': 'Dra kolumner hit eller till platserna till vänster.',
	'LIVE_slots_required_field_description': '%{asterisk} Betecknar ett obligatoriskt fält',
	'LIVE_slots_drag_and_drop_description': 'Dra data till platserna för att skapa och filtrera visualiseringen.',
	'requiredField': 'Obligatoriskt fält',
	'fullScreenEnter': 'Öppna helskärm',
	'fullScreenClose': 'Stäng helskärm',
	'noExtraText_multipurpose': 'Flerfunktionsplatshållare',
	'noExtraText_multipurpose_numbered': 'Flerfunktionsplatshållare (%{number})',
	'one_placeholder_vis': 'Visualiseringsplatshållare',
	'one_placeholder_vis_numbered': 'Visualiseringsplatshållare (%{number})',
	'one_placeholder_text': 'Textplatshållare',
	'one_placeholder_text_numbered': 'Textplatshållare (%{number})',
	'few_placeholder_text': 'Grupp av %{count} textplatshållare',
	'many_placeholder_text': 'Grupp av %{count} textplatshållare',
	'filter_includesAll': 'Inkluderar alla',
	'timeline_filter_moved_to': 'Tidslinjefilter %{id} flyttat till %{time}',
	'timelineSettingsButton': 'Uppspelningsalternativ',
	'autoPlay': 'Spela alla scener',
	'loop': 'Slinga',
	'noSceneTransitionLabel': 'Inget',
	'sceneTransitionPropertyLabel': 'Scenöverföring',
	'animatedPathSceneTransitionLabel': 'Animeringsväg',
	'sweepSceneTransitionLabel': 'Svep',
	'propAniAnimation': 'Animering',
	'propAniTypeEntrance': 'Ingångsanimering',
	'propAniDirectionIn': 'Ingångsriktning',
	'propAniTypeExit': 'Utgångsanimering',
	'propAniDirectionOut': 'Utgångsriktning',
	'propAniDirection': 'Riktning',
	'timelineAnimationProperties': 'Öppna animeringsegenskaper',
	'editStoryCoachMarkTitle': 'Ändra berättelse',
	'editStoryCoachMarkContents': 'Klicka på penseln om du vill ändra berättelsen.',
	'addDataStoryCoachMarkContents': 'Dra data från datapanelen till berättelsen.',
	'expandSceneCoachmarkTitle': 'Öppen tidslinje',
	'expandSceneCoachmarkContents': 'Animera en scen genom att justera objektvisibiliteten baserat på tid och längd.',
	'overviewCoachmarkTitle': 'Översiktsscener',
	'overviewCoachmarkContents': 'Använd översiktsscenerna i början och slutet av berättelsen för att visa den stora bilden för alla scener. Klicka och dra en scen från en översiktsscen för att växla till en annan scen. Du kan visa eller dölja översiktsscener i egenskaperna.',
	'animatedPathCoachmarkTitle': 'Animeringsväg',
	'animatedPathCoachmarkContents': 'Animera ett objekt från en scen till en annan genom att kopiera en scen med ett objekt. Flytta, ändra storlek på eller rotera sedan det kopierade objektet på den nya scenen.',
	'tabName_animation': 'Animering',
	'textWidgetIconPlaceholderText': 'Klicka om du vill lägga till text',
	'buildVisHeader': 'Skapa en visualisering',
	'visIconPlaceholderText': 'Dra och släpp fält för att bygga en visualisering',
	'launchNewExplore': 'Ny utforskning',
	'addTo': 'Lägg till i',
	'addToExisting': 'Lägg till i befintlig...',
	'exploreData': 'Utforska',
	'explore_remove_widget_styles': 'Anpassade visualiseringsegenskaper som färginställningar kommer inte att behållas i utforskningen.',
	'editNotebook': 'Ändra widget',
	'thumbnails_error_fetching': 'Fel vid hämtning av miniatyrer',
	'copy': '%{count} resurs(er) kopierades',
	'specConvertErr': 'Ett fel uppstod vid inklistring eller konvertering av kontrollpanelspecifikation',
	'specCopyErr': 'Fel vid kopiering av kontrollpanelspecifikation',
	'pasteNotSupportedErr': 'Det går inte att klistra in från en %{name}.',
	'reportParam': 'rapport',
	'filterWidgetCopyWarn': 'Filtervisualiseringen kopierades inte eftersom filter inte hanteras just nu.',
	'upgradingDashboard': 'Uppgraderar "%{name}" för %{version}...',
	'upgradeComplete': 'Uppgraderingen är klar',
	'individualTabProperties': 'Egenskaper för enskild flik',
	'propMasterTabStylesLabel': 'Format för huvudflik',
	'propTabPosition': 'Flikplacering',
	'propTabTitle': 'Rubrik',
	'propTabBackgroundColor': 'Fyllningsfärg',
	'propTabTextColor': 'Rubrikfärg',
	'propTabSelectedBarColor': 'Färg på vald stapel',
	'propTabRestoreDefaults': 'Återställ till standardvärden',
	'propIndividualTabStylesLabel': 'Format för enskild flik',
	'propIndividualTabStylesAriaLabel': 'Öppna egenskaper för format för enskild flik',
	'propTabIconPosition': 'Ikonplacering',
	'propLeftTitle': 'Till vänster om rubriken',
	'propRightTitle': 'Till höger om rubriken',
	'propTopTitle': 'Ovanför rubriken',
	'propBottomTitle': 'Nedanför rubriken',
	'propTabIconLabel': 'Visuell',
	'propTabIcon': 'Ikon',
	'propTabIconColor': 'Ikonfärg',
	'no_icon': 'Tom',
	'announcement': 'Meddelande',
	'api': 'Api',
	'archive': 'Arkiv',
	'asset': 'Resurs',
	'attachment': 'Bilaga',
	'audio': 'Ljud',
	'bee': 'Bee',
	'blog': 'Blogg',
	'bookmark': 'Bokmärke',
	'calendar': 'Kalender',
	'camera': 'Kamera',
	'capability': 'Befogenhet',
	'catalog': 'Katalog',
	'chat_message': 'Chattmeddelande',
	'checkout_cart': 'Utcheckningskorg',
	'client': 'Klient',
	'clock': 'Klocka',
	'cloud': 'Moln',
	'code': 'Kod',
	'data_quality': 'Datakvalitet',
	'folder': 'Mappar',
	'forum': 'Forum',
	'glasses': 'Glasögon',
	'group': 'Grupp',
	'hat': 'Hatt',
	'headphone': 'Hörlur',
	'hills': 'Kullar',
	'home': 'Startsida',
	'idea': 'Idé',
	'image': 'Bild',
	'inventory': 'Inventarier',
	'like': 'Gilla',
	'link': 'Länk',
	'location': 'Plats',
	'manage': 'Hantera',
	'pen': 'Penna',
	'mobile_phone': 'Mobiltelefon',
	'music': 'Musik',
	'notifications': 'Aviseringar',
	'paint': 'Måla',
	'payment': 'Betalning',
	'password_key': 'Lösenordsnyckel',
	'people': 'Personer',
	'person': 'Person',
	'phone': 'Telefon',
	'pin': 'Fäst',
	'print': 'Skriv ut',
	'recording': 'Spelar in',
	'repository': 'Behållare',
	'role': 'Roll',
	'search': 'Sök',
	'properties': 'Egenskaper',
	'speaker': 'Högtalare',
	'star': 'Stjärna',
	'tag': 'Kod',
	'thumbs_up': 'Tumme upp',
	'thumbs_down': 'Tumme ned',
	'tools': 'Verktyg',
	'traffic': 'Trafik',
	'trash': 'Papperskorg',
	'twitter': 'Twitter',
	'unknown': 'Okänt',
	'user': 'Användare',
	'venn_diagram': 'Venndiagram',
	'video': 'Video',
	'view': 'Visa',
	'warning': 'Varning',
	'watch': 'Bevaka',
	'watson': 'Watson',
	'wikis': 'Wikis',
	'workspace': 'Arbetsyta',
	'world': 'Världen',
	'OnLoadFilterModifierDatasourceMismatch': 'Filter tillämpas inte på målet eftersom kontrollpanelerna använder olika källor.',
	'OnLoadFilterModifierColumnMismatch': 'Ett eller flera filter tillämpades inte eftersom de matchande kolumnerna inte hittades.',
	'eventGroupButtonLabel': 'visa widgetkopplingar',
	'dockToolbar': 'Docka verktygsfält',
	'undockToolbar': 'Koppla loss verktygsfält',
	'propShowTitle': 'Visa rubrik'
});
